import { Box, Skeleton, Stack, Typography } from "@mui/material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import { styled } from "@mui/material/styles";

export const Header = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  boxShadow: `0px 6px 20px 0px ${theme.colors.action.hoverShadow}`,
}));

export const ListIcon = styled(FormatListBulletedIcon)(({ theme }) => ({
  color: theme.colors.primary.slalomBlue,
}))

export const HeaderTextSkeleton = styled(Skeleton)(({ theme }) => ({
  [theme.breakpoints.up("mobile")]: {
    width: "100%",
  },
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
  },
  [theme.breakpoints.up("desktop")]: {
    width: "60%",
  },
  height: "48px",
}));

export const HeaderText = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.up("mobile")]: {
    width: "100%",
  },
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
  },
  [theme.breakpoints.up("desktop")]: {
    width: "60%",
  },
}));

export const HeaderStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const HeaderActionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.up("mobile")]: {
    width: "100%",
  },
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
    justifyContent: "right",
  },
  [theme.breakpoints.up("desktop")]: {
    width: "40%",
    justifyContent: "right",
  },
}));

export const LinkButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 0.7,
  },
}));
